import React from "react"

// road map data
const road_map_data = [
  {
    step: 1,
    percent: 1,
    title:"Development and Launch",
    heading: "Token Creation and Smart Contract Development",
    desc: "Create the PantherAI token smart contract with BEP20 standards.",
    lists: ["DEX Website Development", "Design user interface (UI/UX)", "Implement backend infrastructure", "Security Audit","Launch Preparation","Prepare marketing materials", "Plan the token launch strategy", "Token Presale" ],
  },
  {
    step: 2,
    percent: 2,
    title:"Token Listing",
    heading: "Launch and Initial Operations",
    desc: "List PantherAI token on decentralized exchanges (DEXs) and centralized exchanges (CEXs) to increase accessibility and liquidity",
    lists: [
      "DEX Beta Launch", 
    "Launch the DEX website in beta mode",
     "Allowing users to trade PantherAI tokens",
     "Community Building",
     "Implement a community governance model",
     "Involve token holders in decision-making processes",
    ],
  },
  {
    step: 3,
    percent: 3,
    title:"Growth and Expansion",
    heading: "Enhanced Features",
    desc: "Continuously improve the DEX website by adding new features such as limit orders, charting tools, and advanced trading options.",
    lists: [
      "Partnerships and Integrations", 
      "Forge strategic partnerships with other projects",
      "Education and Adoption",
      "Educate users about decentralized finance (DeFi)",
      "Promote the advantages of using PantherAI",
      "Marketing Campaigns",
      "DEX for trading.",
    ],
  },
  {
    step: 4,
    percent: 4,
    title:"Scalability Performance",
    heading: "Long-Term Sustainability",
    desc: "Implement scalability solutions to handle increased transaction volume and ensure optimal performance of the DEX platform.",
    lists: [
      "Regulatory Compliance", 
      "Stay updated on regulatory developments",
      "Maintain the project's long-term viability.",
      "Ecosystem Growth",
      "Supporting developers to build decentralized applications (dApps)",
      "Community Empowerment",
      "Exploring new technologies, protocols, and opportunities for expansion.",
    ],
  },
  
]

const RoadMapAreaThree = () => {
  return (
    <section
      id="roadmap"
      className="roadmap-area roadmap-style-three section-pt-70 section-pb-30"
    >
      <div className="container">
        <div
          className="row justify-content-center"
          data-anime="opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: 100;"
        >
          <div className="col-xl-8 col-lg-10">
            <div className="section__title text-center title-mb-80">
              <h2 className="title">
                PAI's <span className="tg-text-gradient">Roadmap</span>
              </h2>
            </div>
          </div>
        </div>
        <div
          className="roadmap__wrapper-three"
          data-anime="targets: > * > * > *; opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: anime.stagger(100);"
        >
          <div className="row justify-content-center">
            {road_map_data.map(item => (
            <div key={item.step} className="col-lg-6 col-md-6 col-sm-9">
              <div className="roadmap__card style-three">
                <div className="roadmap__percent">
                  <span>{item.percent}</span>
                </div>
                <div className="roadmap__step">
                  <span className="tg-text-gradient d-inline-flex">
                     {item.title}
                  </span>
                </div>
                <h3 className="roadmap__heading">{item.heading}</h3>
                <p>
                  {item.desc}
                </p>
                <ul className="roadmap__lists list-wrap">
                  {item.lists.map((l,i) => (
                  <li key={i}>
                    <i className="unicon-checkmark-outline tg-text-gradient d-inline-flex"></i>
                    {l}
                  </li>
                  ))}
                </ul>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default RoadMapAreaThree
